import React, { useEffect, ComponentProps } from 'react';
import { isMobileScreen } from '@apply/ui';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { Footer } from '../../../common_v2/components/Footer';
import { Button } from '@apply/components';
import { ApplicationEntryPanel } from './ApplicationEntryPanel';
import { MobileApplicationEntryPanel } from './MobileApplicationEntryPanel';
import '../../scss/_applicationEntryLayout.scss';

const mobileScreen = isMobileScreen();

//Replace with app specific crumbs
const applicationEntrySections = [
    { id: 'basicInfoCrumb', number: 1, children: 'Basic Info', enabled: false },
    { id: 'propertyCrumb', number: 2, children: 'Property', enabled: false },
    { id: 'budgetCrumb', number: 3, children: 'Budget', enabled: false },
    { id: 'specsCrumb', number: 4, children: 'Specs', enabled: false },
    { id: 'reviewCrumb', number: 5, children: 'Review', enabled: false },
];

type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryV2Props {
    children: any;
    currentSection: number;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    previousStepButtonVisible?: boolean;
    propertyAddress?: string;
}

export const ApplicationEntryLayout: React.FC<ApplicationEntryV2Props> = ({
    children,
    currentSection,
    printMode,
    saveAndExitButtonProps,
    nextStepButtonProps,
    previousStepButtonVisible = true,
    propertyAddress,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry'>
                {!mobileScreen && (
                    <ApplicationEntryPanel
                        sections={applicationEntrySections}
                        currentSection={currentSection}
                        saveAndExitButtonProps={saveAndExitButtonProps}
                        nextStepButtonProps={nextStepButtonProps}
                        previousStepButtonVisible={previousStepButtonVisible}
                    >
                        {children}
                    </ApplicationEntryPanel>
                )}
                {mobileScreen && (
                    <MobileApplicationEntryPanel
                        sections={applicationEntrySections}
                        currentSection={currentSection}
                        saveAndExitButtonProps={saveAndExitButtonProps}
                        nextStepButtonProps={nextStepButtonProps}
                        previousStepButtonVisible={previousStepButtonVisible}
                        propertyAddress={propertyAddress}
                    >
                        {children}
                    </MobileApplicationEntryPanel>
                )}
            </div>
            <Footer />
        </>
    );
};
